// Centralized data-testid constants
export const NAV = {
    landingCta: "landing-cta-button",
    landingChatCta: "landing-chat-cta-button",
    langSwitcher: "language-switcher-button",
    tabSimulator: "tab-simulator",
    tabCrm: "tab-crm",
    tabPeda: "tab-peda",
    tabIntegrations: "tab-integrations",
    tabSettings: "tab-settings",
    tabLanding: "tab-landing",
    adminLogout: "admin-logout-button",
};

export const AUTH = {
    passwordInput: "admin-password-input",
    submitBtn: "admin-login-submit",
    errorMsg: "admin-login-error",
};

export const BOT = {
    messageInput: "bot-message-input",
    sendBtn: "bot-send-button",
    quickReply: (i) => `bot-quick-reply-${i}`,
    leadSubmitBtn: "bot-lead-submit",
    nameInput: "bot-name-input",
    phoneInput: "bot-phone-input",
    emailInput: "bot-email-input",
    courseSelect: "bot-course-select",
    bagrutInput: "bot-bagrut-input",
    psychInput: "bot-psych-input",
    successMsg: "bot-success-message",
};

export const CRM = {
    filterStatus: "crm-filter-status",
    filterCourse: "crm-filter-course",
    searchInput: "crm-search-input",
    leadRow: (id) => `crm-lead-row-${id}`,
    leadDetail: "crm-lead-detail",
    statsTotal: "crm-stats-total",
    statsHot: "crm-stats-hot",
    statsAvgBagrut: "crm-stats-avg-bagrut",
    statsAvgPsych: "crm-stats-avg-psych",
    updateStatusSelect: "crm-update-status-select",
    closeDetailBtn: "crm-close-detail-btn",
};

export const PEDA = {
    courseCard: (id) => `peda-course-${id}`,
    optionBtn: (key) => `peda-option-${key}`,
    submitAnswerBtn: "peda-submit-answer",
    nextQuestionBtn: "peda-next-question",
    rationaleBox: "peda-rationale",
    backToCoursesBtn: "peda-back-courses",
};

export const INT = {
    copyBtn: (id) => `int-copy-${id}`,
    qrImg: (id) => `int-qr-${id}`,
};
